import { motion } from 'framer-motion';

// Actions row under the chart; accepts handlers to keep this component dumb
export function ResultsActions({ savedKg, onRetire, onExportBank }: { savedKg: number; onRetire: () => void; onExportBank: () => void }) {
  return (
    <div className="mt-3 flex items-center gap-3 text-sm text-neutral-300">
      <div>Saved CO2: <span className="text-evat-gold">{savedKg.toFixed(2)} kg</span></div>
      <motion.button onClick={onRetire} whileTap={{ scale: 0.97 }} className="px-3 py-1 rounded border border-evat-gold text-evat-gold hover:shadow-neon">Retire Credit</motion.button>
      <motion.button onClick={onExportBank} whileTap={{ scale: 0.97 }} className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon">Export for Bank</motion.button>
    </div>
  );
}

export default ResultsActions;



















